export const MainNavNorm = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Santa Teresa",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/santa-teresa"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/santa-teresa"
          }
        ]
      },
      {
        label: "Sealand",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/sealand"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/sealand"
          }
        ]
      },
      {
        label: "Iloca",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/iloca"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/iloca"
          }
        ]
      },
      {
        label: "Nano Con Con",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/nano-concon"
          },
          {
            label: "Normalización nano01",
            to: "#/normalizacion/nano-concon/01"
          },
          {
            label: "Normalización nano02",
            to: "#/normalizacion/nano-concon/02"
          }
        ]
      },
      {
        label: "Mowi",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/mowi"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/mowi"
          }
        ]
      },
      {
        label: "Aquachile Pargua",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/aqua-chile-ctp"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/aqua-chile-ctp"
          }
        ]
      },
      {
        label: "Aquachile Río Hollemberg",
        content: [
          {
            label: "SCADA ORVF-8188",
            to: "#/SCADAS/aqua-chile-rh-orvf-8188"
          },
          {
            label: "Normalización ORVF-8188",
            to: "#/normalizacion/aqua-chile-rh-orvf-8188"
          },
          {
            label: "SCADA ORVF-8156",
            to: "#/SCADAS/aqua-chile-rh-orvf-8156"
          },
          {
            label: "Normalización ORVF-8156",
            to: "#/normalizacion/aqua-chile-rh-orvf-8156"
          }
        ]
      },
      {
        label: "KO Andina Antofagasta",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/ko-andina-antofagasta"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/ko-andina-antofagasta"
          }
        ]
      },
      {
        label: "A.A. Santa Inés de Patagüilla",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/aguas-andinas-sidp"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/aguas-andinas-sidp"
          }
        ]
      },
      {
        label: "Embonor Talca",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/embonor-talca"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/embonor-talca"
          }
        ]
      },
      {
        label: "Embonor Arica",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/embonor-arica"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/embonor-arica"
          }
        ]
      },
      {
        label: "BLUEBERRIES PERÚ",
        content: [
          {
            label: "TERRANOVA 1",
            content: [
              {
                label: "SCADA",
                to: "#/SCADAS/mission-etapa-1-ro-1"
              },
              {
                label: "Normalización",
                to: "#/normalizacion/mission-ro-1"
              }
            ]
          },
          {
            label: "TERRANOVA 2",
            content: [
              {
                label: "SCADA",
                to: "#/SCADAS/mission-etapa-1-ro-2"
              },
              {
                label: "Normalización",
                to: "#/normalizacion/mission-ro-2"
              }
            ]
          },
          {
            label: "TERRANOVA 3",
            content: [
              {
                label: "SCADA",
                to: "#/SCADAS/mission-etapa-1-ro-3"
              },
              {
                label: "Parámetros eléctricos",
                to: "#/parametros-electricos/mission-ro-3"
              },
              {
                label: "Normalización",
                to: "#/normalizacion/mission-ro-3"
              }
            ]
          },
          {
            label: "TERRANOVA 4",
            content: [
              {
                label: "SCADA",
                to: "#/SCADAS/mission-etapa-1-ro-4"
              },
              {
                label: "Parámetros eléctricos",
                to: "#/parametros-electricos/mission-ro-4"
              },
              {
                label: "Normalización",
                to: "#/normalizacion/mission-ro-4"
              }
            ]
          }
        ]
      },
      {
        label: "PROSEMBRA",
        content: [
          {
            label: "Piscu 1",
            content: [
              {
                label: "SCADA",
                to: "#/SCADAS/piscu"
              },
              {
                label: "Normalización",
                to: "#/normalizacion/piscu"
              }
            ]
          },
          {
            label: "Piscu 2",
            content: [
              {
                label: "SCADA",
                to: "#/SCADAS/piscu-2"
              }
            ]
          }
        ]
      },
      {
        label: "Clariant",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/clariant"
          },
          {
            label: "Normalización clariant 01",
            to: "#/normalizacion/clariant/01"
          },
          {
            label: "Normalización clariant 02",
            to: "#/normalizacion/clariant/02"
          }
        ]
      },
      {
        label: "Agrícola Río Negro",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/agricola-rio-negro"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/agricola-rio-negro"
          }
        ]
      },
      {
        label: "MBR Enap",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/mbr-enap"
          }
        ]
      },
      {
        label: "TA EXPORT",
        content: [
          {
            label: "SCADA - CHANCHAMAYO 1",
            to: "#/SCADAS/chanchamayo"
          },
          {
            label: "Normalización 1",
            to: "#/normalizacion/chanchamayo"
          },
          {
            label: "SCADA - CHANCHAMAYO 2",
            to: "#/SCADAS/chanchamayo-02"
          },
          {
            label: "Normalización 2",
            to: "#/normalizacion/chanchamayo-02"
          }
        ]
      },
      {
        label: "Essbio Piloto",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/essbio-piloto"
          }
        ]
      },
      {
        label: "Codelco DSAL",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/codelco-dsal"
          }
        ]
      },
      {
        label: "BLUEWAY",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/altena"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/altena"
          }
        ]
      }
    ]
  }
];

export const MainNav = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Santa Teresa",
        to: "#/SCADAS/santa-teresa"
      },

      {
        label: "Sealand",
        to: "#/SCADAS/sealand"
      },
      {
        label: "Iloca",
        to: "#/SCADAS/iloca"
      },
      {
        label: "Nano Con Con",
        to: "#/SCADAS/nano-concon"
      },
      {
        label: "Mowi",
        to: "#/SCADAS/mowi"
      },
      {
        label: "Aquachile Pargua",
        to: "#/SCADAS/aqua-chile-ctp"
      },
      {
        label: "Aquachile R.H. ORVF-8188",
        to: "#/SCADAS/aqua-chile-rh-orvf-8188"
      },
      {
        label: "Aquachile R.H. ORVF-8156",
        to: "#/SCADAS/aqua-chile-rh-orvf-8156"
      },
      {
        label: "KO Andina Antofagasta",
        to: "#/SCADAS/ko-andina-antofagasta"
      },
      {
        label: "A.A. Santa Inés de Patagüilla",
        to: "#/SCADAS/aguas-andinas-sidp"
      },
      {
        label: "Embonor Talca",
        to: "#/SCADAS/embonor-talca"
      },
      {
        label: "Embonor Arica",
        to: "#/SCADAS/embonor-arica"
      },
      {
        label: "TERRANOVA 1",
        to: "#/SCADAS/mission-etapa-1-ro-1"
      },
      {
        label: "TERRANOVA 2",
        to: "#/SCADAS/mission-etapa-1-ro-2"
      },
      {
        label: "TERRANOVA 3",
        to: "#/SCADAS/mission-etapa-1-ro-3"
      },
      {
        label: "TERRANOVA 4",
        to: "#/SCADAS/mission-etapa-1-ro-4"
      },
      {
        label: "Clariant",
        to: "#/SCADAS/clariant"
      },
      {
        label: "Agrícola Río Negro",
        to: "#/SCADAS/agricola-rio-negro"
      },
      {
        label: "MBR Enap",
        to: "#/SCADAS/mbr-enap"
      },
      {
        label: "TA EXPORT",
        to: "#/SCADAS/chanchamayo"
      },
      {
        label: "TA EXPORT",
        to: "#/SCADAS/chanchamayo-02"
      },
      {
        label: "BLUEWAY",
        to: "#/SCADAS/altena"
      }
    ]
  }
];

export const NavSantaTeresa = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Santa Teresa",
        to: "#/SCADAS/santa-teresa"
      }
    ]
  }
];

export const NavAdquim = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Adquim",
        to: "#/SCADAS/adquim"
      }
    ]
  }
];

export const NavIloca = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Iloca",
        to: "#/SCADAS/iloca"
      }
    ]
  }
];

/* export const NavMineraTeck = [
  {
      icon: 'pe-7s-network',
      label: 'PLANTAS',
      content: [
          {
              label: 'Minera Teck',
              to: '#/SCADAS/minera-teck',
          }
      ]
  }
]; */

export const NavAguasAndinasSIDP = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "A.A. Santa Inés de Patagüilla",
        to: "#/SCADAS/aguas-andinas-sidp"
      }
    ]
  }
];

export const NavAquaChileCTP = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Aquachile Pargua",
        to: "#/SCADAS/aqua-chile-ctp"
      }
    ]
  }
];

export const NavAquaChileRH = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Aquachile R.H. ORVF-8188",
        to: "#/SCADAS/aqua-chile-rh-orvf-8188"
      },
      {
        label: "Aquachile R.H. ORVF-8156",
        to: "#/SCADAS/aqua-chile-rh-orvf-8156"
      }
    ]
  }
];

export const NavNanoConcon = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Nano Con Con",
        to: "#/SCADAS/nano-concon"
      }
    ]
  }
];

export const NavMowi = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Mowi",
        to: "#/SCADAS/mowi"
      }
    ]
  }
];

export const NavSealand = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Sealand",
        to: "#/SCADAS/sealand"
      }
    ]
  }
];

export const NavBresler = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Bresler",
        to: "#/SCADAS/bresler"
      }
    ]
  }
];

export const NavKoAndinaAntofagasta = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Ko Andina Antofagasta",
        to: "#/SCADAS/ko-andina-antofagasta"
      }
    ]
  }
];

export const NavEmbonorTalca = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Embonor Talca",
        to: "#/SCADAS/embonor-talca"
      }
    ]
  }
];

export const NavCristaleriasChile = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Cristalerías Chile",
        to: "#/SCADAS/cristaleriaschile"
      }
    ]
  }
];

export const NavMission = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "TERRANOVA 1",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/mission-etapa-1-ro-1"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/mission-ro-1"
          }
        ]
      },
      {
        label: "TERRANOVA 2",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/mission-etapa-1-ro-2"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/mission-ro-2"
          }
        ]
      },
      {
        label: "TERRANOVA 3",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/mission-etapa-1-ro-3"
          },
          {
            label: "Parámetros eléctricos",
            to: "#/parametros-electricos/mission-ro-3"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/mission-ro-3"
          }
        ]
      },
      {
        label: "TERRANOVA 4",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/mission-etapa-1-ro-4"
          },
          {
            label: "Parámetros eléctricos",
            to: "#/parametros-electricos/mission-ro-4"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/mission-ro-4"
          }
        ]
      }
    ]
  }
];

export const NavProsembra = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Piscu 1",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/piscu"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/piscu"
          }
        ]
      },
      {
        label: "Piscu 2",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/piscu-2"
          }
        ]
      }
    ]
  }
];

export const NavClariant = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Clariant",
        to: "#/SCADAS/clariant"
      }
    ]
  }
];

export const NavEmbonorArica = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Embonor Arica",
        to: "#/SCADAS/embonor-arica"
      }
    ]
  }
];

export const NavAgricolaRioNegro = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Agrícola Río Negro",
        to: "#/SCADAS/agricola-rio-negro"
      }
    ]
  }
];

export const NavMbrEnap = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "MBR Enap",
        to: "#/SCADAS/mbr-enap"
      }
    ]
  }
];

export const NavChanchamayo = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "SCADA TA EXPORT - Chanchamayo 1",
        to: "#/SCADAS/chanchamayo"
      },
      {
        label: "SCADA TA EXPORT - Chanchamayo 2",
        to: "#/SCADAS/chanchamayo-02"
      }
    ]
  }
];

export const NavAltena = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "BLUEWAY",
        to: "#/SCADAS/altena"
      }
    ]
  }
];







export const NavDemo = [
  {
    icon: "pe-7s-network",
    label: "PLANTAS",
    content: [
      {
        label: "Demo",
        content: [
          {
            label: "SCADA",
            to: "#/SCADAS/demo-scada"
          },
          {
            label: "Normalización",
            to: "#/normalizacion/demo-normalizacion"
          }
        ]
      }
    ]
  }
];

export const NavDemoSeccion = [
  {
    icon: "pe-7s-browser",
    label: "DEMO",
    content: [
      {
        label: "SCADA",
        to: "#/SCADAS/demo-scada"
      },
      {
        label: "Normalización",
        to: "#/normalizacion/demo-normalizacion"
      }
    ]
  }
];

export const NavVisitas = [
  {
    icon: "pe-7s-look",
    label: "VISITAS",
    to: "#/tables/visitas-plantas"
  }
];

export const NavMonitoreoPlantas = [
  {
    icon: "pe-7s-display1",
    label: "MONITOREO PLANTAS",
    to: "#/tables/monitoreo-plantas"
  }
];

export const NavAlarmas = [
  {
    icon: "pe-7s-bell",
    label: "ALARMAS",
    content: [
      {
        label: "Monitoreo de Alarmas",
        to: "#/alarmas/monitoreo"
      }
    ]
  }
];

export const MainNavCreador = [
  {
    icon: "pe-7s-users",
    label: "USUARIOS",
    content: [
      {
        label: "Crear Usuario",
        to: "#/creates/user"
      },
      {
        label: "Administrar Usuarios",
        to: "#/tables/usuarios"
      },
      {
        label: "Historial de Cambios",
        to: "#/tables/historial"
      }
    ]
  }
];

export const PruebasNav = [
  {
    icon: "pe-7s-plugin",
    label: "PRUEBAS",
    content: [
      {
        label: "Registros",
        to: "#/pruebas/registros"
      }
    ]
  }
];

export const MainNav3 = [
  {
    icon: "pe-7s-network",
    label: "Dashboards",
    content: [
      {
        label: "Reportes",
        to: "#/dashboards/minimal-dashboard-1"
      }
    ]
  }
];

export const NavGestionPlantas = [
  {
    icon: "pe-7s-display1",
    label: "GESTIONAR PLANTAS",
    content: [
      {
        label: "Crear Planta",
        to: "#/creates/planta"
      }
    ]
  }
];
